import no_preview from "../../../assets/img/preview_indisponivel.svg";
import { NotFoundMedia } from "./components/not-found-media";
import { CloseButton } from "react-bootstrap";
import { ContentErrorMessage } from "./styled";
import { useState } from "react";

interface IpropTypes {
	fileType?: string;
	filePath?: string;
	preview_index?: string;
	preview_url?: string;
	onError?: any;
	isGeneratingScorm?: boolean;
}

export const FileViewer: React.FC<IpropTypes> = ({
	fileType,
	filePath,
	preview_index,
	preview_url,
	isGeneratingScorm = false,
}) => {
	const [showErrorMessage, setShowErrorMessage] = useState(true);

  	const closeMessage = () => setShowErrorMessage(false);

	const getDriver = () => {
		switch (fileType) {
			// Imagens
			case "image/jpg":
			case "image/jpeg":
			case "image/gif":
			case "image/bmp":
			case "image/png":
			case "jpg":
			case "jpeg":
			case "gif":
			case "bmp":
			case "png": {
				return (
					<img
						src={filePath}
						alt="Media"
						width="100%"
						onError={(e) => {
							e.currentTarget.src = no_preview;
						}}
					></img>
				);
			}
			// PDFs
			case "scorm":
			case "pdf":
			case "application/pdf": {
				return (
					<iframe
						onContextMenu={(e) => e.preventDefault()}
						className="h-100"
						src={filePath + "#toolbar=0"}
						title={filePath}
						width="100%"
					></iframe>
				);
			}
			// .docx do Word
			case "application/msword":
			case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
			case "docx": {
				return (
					<iframe
						onContextMenu={(e) => e.preventDefault()}
						className="h-100"
						src={`https://view.officeapps.live.com/op/embed.aspx?src=${filePath}`}
						title={filePath}
						width="100%"
						frameBorder={"0"}
					></iframe>
				);
			}
			// Vídeos
			case "video/mp4":
			case "video/webm":
			case "video/ogg":
			case "video/*":
			case "webm":
			case "mp4": {
				return (
					<video
						controls
						src={filePath}
						width="100%"
						controlsList="nodownload"
						onContextMenu={(e) => e.preventDefault()}
					>
						Video playback is not supported by your browser.
					</video>
				);
			}
			// Podcasts
			case "audio/mpeg":
			case "audio/mp3":
			case "audio/mp4":
			case "audio/ogg":
			case "audio/wav":
			case "audio/wave":
			case "audio/x-wav":
			case "audio/*":
			case "mp3":
			case "m4a":
			case "ogg":
			case "wav": {
				return (
					<div className="w-100 h-100 d-flex align-items-center justify-content-center">
						<audio
							controls
							src={filePath}
							controlsList="nodownload"
							onContextMenu={(e) => e.preventDefault()}
						>
							Audio playback is not supported by your browser.
						</audio>
					</div>
				);
			}
			// Zipados
			case "zip":
			case "scorm":
			case "application/x-zip-compressed":
			case "application/zip": {
				if (preview_index && preview_url && !isGeneratingScorm) {
					return (
						<>
							{showErrorMessage && (
							    <ContentErrorMessage>
									<p>
									    Para melhor visualização do conteúdo,{" "}
									    <a href={preview_url} target="_blank" rel="noopener noreferrer">
										  abrir em nova aba
									    </a>
									</p>
									<CloseButton
										className="close"
									    onClick={closeMessage}
									    aria-label="Fechar"
									>
									</CloseButton>
								</ContentErrorMessage>
							)}

							<iframe
								className="h-100"
								src={preview_url}
								title={filePath}
								sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
								allow="autoplay; encrypted-media"
								width="100%"
							></iframe>
						</>
					);
				} else if (isGeneratingScorm) {
					return (
						<>
							<NotFoundMedia mode="scorm" />
						</>
					);
				} else {
					return (
						<>
							<NotFoundMedia />
						</>
					);
				}
			}
			default: {
				return (
					<>
						<NotFoundMedia />
					</>
				);
			}
		}
	};
	return (
		<div className="pg-viewer-wrapper h-100">
			{filePath ? (
				<div
					className="pg-viewer h-100"
					id="pg-viewer"
					onContextMenu={(e) => e.preventDefault()}
				>
					{getDriver()}
				</div>
			) : (
				<NotFoundMedia />
			)}
		</div>
	);
};
